import { formatDate } from '@angular/common';
import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { async } from 'rxjs';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { ApiService } from './../../../../../Services/api.service';
import { CommonServices } from './../../../../../Services/common.service';

@Component({
    selector: 'g10-trip-reports',
    templateUrl: './trip-reports-component.html',
    styleUrls: ['./trip-reports-component.css']
})
export class TripReportsComponent implements OnInit {

    public matFormSize = '12px';
    public searchForm: FormGroup;

    public noDataFoundEnable: boolean = false;
    public excelData = {};

    public maxDate = new Date();
    public maxEndDate = new Date();
    date = new Date();

    public errorObject: any = {
        startDate: '',
        endDate: '',
    }
    public formSubmitted: boolean = false;


    public safeDropEmpExlData = [{
        "date": 1679596200000,
        "distance": "62.89",
        "duration": "01:36:20",
        "vehRegNo": "TN60SA1561",
        "routeName": "Login",
        "startLoc": " Guindy, Chennai, Tamil Nadu, India",
        "startTs": "06:00",
        "endLoc": " Taramani, Chennai, Tamil Nadu, India",
        "endTs": "10:00"
    }];
    public tripReportsData = [
        {

            "vehRegNo": "TN51AB4545",
            "distance": 237,
            "tripCount": 4,
        }

    ]


    public showTable: boolean = true;
    public cols: any = [
        { key: '#', display: '#' },
        { key: 'routeName', display: 'Route name',headerConfig:{ isDefault: true} },
        {
            key: 'vehRegNo', display: 'Reg no',
            config: {
                isVehicle: true,
            },
            headerConfig:{ isDefault: true}
        },
        { key: 'date', display: 'Date', config: { isDate: true, format: 'dd MMM YYYY' } },
        { key: 'startTs', display: 'Start time',headerConfig:{ isDefault: true} },
        { key: 'startLoc', display: 'Start location',headerConfig:{ isDefault: true} },
        { key: 'endTs', display: 'End time',headerConfig:{ isDefault: true} },
        { key: 'endLoc', display: 'End location',headerConfig:{ isDefault: true} },
        { key: 'duration', display: 'Duration' },
        { key: 'distance', display: 'Distance (km)',headerConfig:{ isDefault: true} },

    ];

    public tableData: any = [
        {
            "date": 1679596200000,
            "distance": "20.14",
            "duration": "01:10:02",
            "vehRegNo": "TN01RR1155",
            "routeName": "Login",
            "startLoc": " Chromepet, Chennai, Tamil Nadu, India",
            "startTs": "06:00",
            "endLoc": " Taramani, Chennai, Tamil Nadu, India",
            "endTs": "08:30"
        },

        {
            "date": 1679596200000,
            "distance": "24.89",
            "duration": "01:36:20",
            "vehRegNo": "TN07CV8257",
            "routeName": "Login",
            "startLoc": " Tambaram, Chennai, Tamil Nadu, India",
            "startTs": "07:00",
            "endLoc": " Taramani, Chennai, Tamil Nadu, India",
            "endTs": "09:00"
        },
        {
            "date": 1679596200000,
            "distance": "12.91",
            "duration": "00:36:20",
            "vehRegNo": "TN07CV8223",
            "routeName": "Login",
            "startLoc": " Medavakkam, Chennai, Tamil Nadu, India",
            "startTs": "08:00",
            "endLoc": " Taramani, Chennai, Tamil Nadu, India",
            "endTs": "09:00"
        },
        {
            "date": 1679596200000,
            "distance": "15.89",
            "duration": "00:36:20",
            "vehRegNo": "TN60SA1561",
            "routeName": "Login",
            "startLoc": " Guindy, Chennai, Tamil Nadu, India",
            "startTs": "08:00",
            "endLoc": " Taramani, Chennai, Tamil Nadu, India",
            "endTs": "10:00"
        },

        {
            "date": 1679596200000,
            "distance": "08.89",
            "duration": "00:20:20",
            "vehRegNo": "TN57AA0004",
            "routeName": "Login",
            "startLoc": " Velachery, Chennai, Tamil Nadu, India",
            "startTs": "09:00",
            "endLoc": " Taramani, Chennai, Tamil Nadu, India",
            "endTs": "10:00"
        }
    ]

    public showDownloadBtn: boolean = false;
    public empDetails: any = {};
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private api: ApiService,
        private com: CommonServices,
        private fb: FormBuilder,
        public excel: ExcelExportService,
    ) { }

    ngOnInit(): void {
        this.searchFormLoad();
    }

    searchFormLoad() {
        this.searchForm = this.fb.group({
            search: new FormControl(''),
            startDate: new FormControl(new Date(), [Validators.required]),
            endDate: new FormControl(new Date(), [Validators.required]),
            transitMode: new FormControl(''),
        });
    }


    validation(data) {
        if (this.errorObject['invalidDate']) delete this.errorObject['invalidDate'];
        let objectKeys = Object.keys(this.errorObject);
        let isValid = true;
        for (let i = 0; i < objectKeys.length; i++) {
            let key = objectKeys[i];
            this.errorObject[key] = '';
            if (data[key] == '' || data[key] == undefined || data[key] == null || Number.isNaN(data[key]) || data.length <= 0) {
                this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
                isValid = false;
            } else if ((key == 'startDate' || key == 'endDate')) {
                if (new Date(data.startDate).getTime() > new Date(data.endDate).getTime()) {
                    isValid = false;
                    this.errorObject['invalidDate'] = 'Invalid from date';
                }
            }
        }
        return isValid;
    }

    checkValidation() {
        let obj = {
            startDate: new Date(this.searchForm.value.startDate).getTime(),
            endDate: new Date(this.searchForm.value.endDate).getTime(),
        }
        if (this.formSubmitted) this.validation(obj);
    }

    onSubmit() {
        console.log(this.searchForm.value);
        this.formSubmitted = true;
        let checkObj = {
            startDate: new Date(this.searchForm.value.startDate).getTime(),
            endDate: new Date(this.searchForm.value.endDate).getTime(),
            search: this.searchForm.value.search,
        }
        let isValid = this.validation(checkObj);
        if (isValid) {
            let obj = {
                startDate: new Date(new Date(this.searchForm.value.startDate).setHours(0)).getTime(),
                endDate: new Date(new Date(this.searchForm.value.endDate).setHours(23, 59, 59)).getTime(),
            }
            if (this.searchForm.value.search != '') obj['search'] = this.searchForm.value.search;
            if (this.searchForm.value.transitMode != '') obj['transitMode'] = this.searchForm.value.transitMode;
            // this.processData(obj);
            console.log(obj);
        }
    }

    navToTripCount() {
        this.router.navigateByUrl('/organization/transport-manager/reports/trip-count')
    }

    processData(formObject) {
        return new Promise(async (resolve, reject) => {
            try {
                let vehObj = {};
                if (formObject && formObject.search && formObject.search != '') vehObj['vehRegNo'] = formObject.search
                let vehicles: any = await this.com.getAPILoopData('transportManagerVehicleList', vehObj).catch((err) => { throw ({ 'error': err }) })

                let vehRegString: string = '';
                vehicles.map((veh) => { vehRegString += veh['vehRegNo'] + ',' })
                let vehRegEncryKey = await this.getVehicleEncryptRegNo(vehRegString).catch((e) => { console.log('unable to veh reg no'); })

                const startDate = new Date(formObject.startDate);
                const endDate = new Date(formObject.endDate);
                const start = startDate.getFullYear() + '/' + this.com.pad(startDate.getMonth() + 1) + '/' + this.com.pad(startDate.getDate());
                const end = endDate.getFullYear() + '/' + this.com.pad(endDate.getMonth() + 1) + '/' + this.com.pad(endDate.getDate());
                let daylist: any = this.getDaysArray(new Date(start), new Date(end));
                daylist = [...new Set(daylist)];

                let dayVehData = {};
                let dayRouteData = {};

                const currenDayRoute: any = await this.com.currentDayRouteData({}).catch((err) => console.log(err));
                for (let day = 0; day < daylist.length; day++) {

                    let checkDay = this.checkCurrentDay(daylist[day]);

                    for (let veh = 0; veh < vehicles.length; veh++) {
                        let vehRegNo = vehicles[veh]['vehRegNo'];
                        if (vehRegNo != undefined) {
                            if (dayVehData[daylist[day]] == undefined) dayVehData[daylist[day]] = {};
                            if (dayRouteData[daylist[day]] == undefined) dayRouteData[daylist[day]] = [];
                            if (!checkDay) {

                                if (vehRegEncryKey[vehRegNo] != null) {
                                    const splitDate = daylist[day].split('/');
                                    const date = splitDate[2] + splitDate[1] + splitDate[0].slice(-2);
                                    const url = date + '/' + vehRegEncryKey[vehRegNo] + '.z';
                                    const res: any = await this.api.readS3Data(url).catch((e) => { });
                                    if (JSON.stringify(res) != '{}' && res != undefined && res != null && res != '') {
                                        if (dayVehData[daylist[day]][vehRegNo] == undefined) dayVehData[daylist[day]][vehRegNo] = [];
                                        dayVehData[daylist[day]][vehRegNo] = [...res];
                                    }
                                }
                            }
                            else {
                                let obj = {
                                    vehRegNo: vehRegNo,
                                    date: new Date().setHours(0, 0, 0, 0)
                                };
                                if (dayVehData[daylist[day]][vehRegNo] == undefined) { dayVehData[daylist[day]][vehRegNo] = {}; }
                                const getData: any = await this.com.currentDayTrackingData(obj).catch((e) => { console.log('Unable to get current day data.'); });
                                if (dayVehData[daylist[day]][vehRegNo] == undefined) dayVehData[daylist[day]][vehRegNo] = [];
                                if (getData && Array.isArray(getData) && getData.length > 0) dayVehData[daylist[day]][vehRegNo] = [...getData];
                            }
                        }
                    }

                    // const currenDayRoute:any = await this.com.currentDayRouteData({}).catch((err)=>console.log(err));
                    // if(!checkDay){
                    // }else{
                    //         console.log(currenDayRoute)
                    // }

                    if (currenDayRoute && currenDayRoute.length > 0) {
                        dayRouteData[daylist[day]] = currenDayRoute;
                    }
                }

                Object.keys(dayRouteData).map((day: any) => {
                    console.log(dayRouteData[day]);
                    if (dayRouteData[day] && dayRouteData[day].length > 0) {
                        const date = new Date(day).getTime();
                        for (let r = 0; r < dayRouteData[day].length; r++) {
                            const route: any = dayRouteData[day][r];

                            if (route && route['vehicle'] && route['vehicle'].length > 0) {

                                let routeStrTime = new Date(new Date(date).setHours(0, 0, 0, 0)).getTime();
                                let routeEndTime = new Date(new Date(date).setHours(23, 59, 59, 999)).getTime();

                                if (route['startTimeStr'] && route['startTimeStr'] != '') {
                                    let [strHr, strMin] = String(route['startTimeStr']).split(':');
                                    routeStrTime = new Date(new Date(date).setHours(+strHr, +strMin - 15, 0, 0)).getTime();
                                }
                                if (route['endTimeStr'] && route['endTimeStr'] != '') {
                                    let [endHr, endMin] = String(route['endTimeStr']).split(':');
                                    routeEndTime = new Date(new Date(date).setHours(+endHr, +endMin + 15, 0, 0)).getTime();
                                }

                                const vehicles = route['vehicle'];

                                if (vehicles && vehicles.length > 0) {
                                    for (let v = 0; v < vehicles.length; v++) {

                                        const veh = vehicles[v];
                                        if (dayVehData[day][veh] && dayVehData[day][veh].length > 0) {

                                            const filteredRouteVehTrack = dayVehData[day][veh].map((item: any) => {
                                                if (item['gpsts']) {
                                                    const gpsts = item['gpsts'] * 1000;
                                                    if (routeStrTime < gpsts && gpsts < routeEndTime) {
                                                        return item;
                                                    }
                                                }
                                            }).filter((item) => item != undefined);
                                            if (filteredRouteVehTrack && filteredRouteVehTrack.length > 0) {
                                                let totalDis: any = 0;
                                                let totalDur: any = '00:00:00';
                                                let timeDuration = 0;

                                                for (let c = 0; c < filteredRouteVehTrack.length; c++) {
                                                    if (c > 1) {
                                                        let prevKey = c - 1;
                                                        let curKey = c;
                                                        let curdis = 0;
                                                        const lat1 = parseFloat(filteredRouteVehTrack[curKey].lat);
                                                        const lat2 = parseFloat(filteredRouteVehTrack[prevKey].lat);
                                                        const lng1 = parseFloat(filteredRouteVehTrack[curKey].lng);
                                                        const lng2 = parseFloat(filteredRouteVehTrack[prevKey].lng);
                                                        console.log(veh, lat1, lng1, lat2, lng2)
                                                        if ((lat1 == lat2) && (lng1 == lng2)) {
                                                            curdis = 0;
                                                        }
                                                        else {
                                                            const radlat1 = Math.PI * lat1 / 180.0;
                                                            const radlat2 = Math.PI * lat2 / 180.0;
                                                            const theta = lng1 - lng2;
                                                            const radtheta = Math.PI * theta / 180.0;
                                                            let dist: any = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                                                            if (dist > 1) {
                                                                dist = 1;
                                                            }
                                                            dist = Math.acos(dist);
                                                            dist = dist * 180 / Math.PI;
                                                            dist = dist * 60 * 1.1515;
                                                            dist = (dist * 1.609344);
                                                            curdis = parseFloat(dist);
                                                        }
                                                        console.log(Number(parseFloat(totalDis)) + ' + ' + Number(curdis))
                                                        totalDis = Number(parseFloat(totalDis)) + Number(curdis);

                                                        let timeValue = this.com.timeDiff(filteredRouteVehTrack[prevKey].gpsts, filteredRouteVehTrack[curKey].gpsts);
                                                        timeDuration = timeValue.seconds ? (timeDuration + timeValue.seconds) : (timeDuration + 0);
                                                        let seconds = Math.floor(timeDuration);
                                                        let minute = Math.floor(seconds / 60);
                                                        seconds = seconds % 60;
                                                        let hour = Math.floor(minute / 60);
                                                        minute = minute % 60;
                                                        totalDur = (('' + hour).length == 1 ? '0' + hour : hour) + ':' + (('' + minute).length == 1 ? '0' + minute : minute) + ':' + (('' + seconds).length == 1 ? '0' + seconds : seconds);
                                                        // console.log('total duration',totalDur);
                                                    }

                                                }
                                                let resValue = {
                                                    date: date,
                                                    distance: totalDis.toFixed(2),
                                                    duration: totalDur,
                                                    vehRegNo: veh,
                                                    routeName: route['title'],
                                                    startLoc: filteredRouteVehTrack[0]['near'].split(',').filter((str, i) => i != 0).join(','),
                                                    startTs: route['startTimeStr'],
                                                    endLoc: filteredRouteVehTrack[filteredRouteVehTrack.length - 1]['near'].split(',').filter((str, i) => i != 0).join(','),
                                                    endTs: route['endTimeStr'],
                                                }
                                                this.tableData.push(resValue);
                                            }

                                        }

                                    }
                                }
                            }

                        }
                    }
                })

                console.log(this.tableData)
            } catch (err) {
                console.log(err);
                this.noDataFoundEnable = true;
            }
        })
    }

    getDaysArray(start, end) {
        let arr = [];
        for (const dt: Date = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
            const date = new Date(dt);
            arr.push(date.getFullYear() + '/' + this.com.pad(date.getMonth() + 1) + '/' + this.com.pad(date.getDate()));
        }
        return arr;
    };

    checkCurrentDay(date) {
        var inputDate = new Date(date);
        // Get today's date
        var todaysDate = new Date();
        // call setHours to take the time out of the comparison
        if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) return true;
        else return false;
    };

    async getVehicleEncryptRegNo(regNo) {
        return new Promise((resolve, rejects) => {
            this.api.getVehicleRegNo({ vehRegNo: regNo }).then((res) => {
                if (res['status'] == 'success') resolve(res['data']);
                else rejects(res['data'])
            })
        })
    }

    async exportToExcel() {
        let data = [];

        const startDate = new Date(this.searchForm.value.startDate + '');
        const endDate = new Date(new Date(this.searchForm.value.endDate + '').setHours(23, 59, 59));

        for (let i = 0; i < this.tableData.length; i++) {
            let item = this.tableData[i];
            try {
                let res = [
                    i + 1,
                    item.routeName ? this.com.convertTitleCase(item.routeName) : '---',
                    item.vehRegNo ? item.vehRegNo : '---',
                    item.date ? formatDate(item.date, 'dd/MMM/yyyy', 'en-In') : '--/--/----',
                    item.startTs ? item.startTs : '--:--',
                    item.startLoc ? item.startLoc : '---',
                    item.endTs ? item.endTs : '--:--',
                    item.endLoc ? item.endLoc : '---',
                    item.duration ? item.duration : '--:--:--',
                    item.distance ? item.distance : '0'
                ];
                data.push(res);
            } catch (err) {
                console.log(err);
            }
        }
        if (data.length > 0) {

            const excelInfo = {
                title: {
                    title: `Trip Report`,
                    //   subTitleRow: 'Date : ' + this.com.timestampToDate(new Date(startDate).getTime(), 'DMY H:M:S') + ' to ' + this.com.timestampToDate(new Date(endDate).getTime(), 'DMY H:M:S') ,
                    font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true },
                    mergeCells: 'A1:J2',
                    fill: {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: '966462AF' },
                        bgColor: { argb: '966462AF' }
                    },
                    alignment: {
                        cell: 'A1', value: { vertical: 'middle', horizontal: 'center' },
                    },
                },
                header: {
                    headers: ['S No', 'Route', 'Reg no', 'Date', 'Start time', 'Start location', 'End time', 'End location', 'Duration', 'Distance (km)'],
                    fill: {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFFFFF00' },
                        bgColor: { argb: 'FF0000FF' }
                    },
                    border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
                },
                data: {
                    data: data,
                    columWith: [{ colNo: 2, width: 20 }, { colNo: 3, width: 15 }, { colNo: 4, width: 15 }, { colNo: 5, width: 10 }, { colNo: 6, width: 25 }, { colNo: 7, width: 10 }, { colNo: 8, width: 25 }, { colNo: 9, width: 10 }, { colNo: 10, width: 15 }]
                }
            };

            if (this.excelData['Trip_Report'] == undefined) { this.excelData['Trip_Report'] = {}; }

            this.excelData['Trip_Report'] = excelInfo;

            this.showDownloadBtn = true;
        }
        this.downloadExlReport()
    }

    downloadExlReport() {
        this.excel.generateExcel(this.excelData, 'Trip_Report_' + new Date().getTime() + '.xlsx');
    }
}
